import { t as e } from "../../constants-B7fXbm2f.js";
import { t } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as n, createElementVNode as r, normalizeClass as i, openBlock as a } from "vue";
//#region ../src/icons/line-chart.vue
var o = {
	name: "DtIconLineChart",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (t) => Object.keys(e).includes(t)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return e[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded");
	}
}, s = [
	"aria-label",
	"data-qa",
	"aria-hidden"
];
function c(e, t, o, c, l, u) {
	return a(), n("svg", {
		"aria-label": o.ariaLabel,
		class: i([u.iconSizeClass, "d-icon d-icon--line-chart"]),
		"data-qa": u.dataQA,
		"aria-hidden": u.ariaHidden,
		role: "img",
		"data-name": "Line Chart",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 12 12"
	}, [...t[0] || (t[0] = [r("path", {
		fill: "currentColor",
		"fill-rule": "evenodd",
		d: "M1.5 1a.5.5 0 0 1 .5.5V10h8.5a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5v-9a.5.5 0 0 1 .5-.5Zm7.646 3.146a.5.5 0 1 1 .708.708l-2.5 2.5a.5.5 0 0 1-.708 0L5 5.707 3.854 6.854a.5.5 0 1 1-.708-.708l1.5-1.5a.5.5 0 0 1 .708 0L7 6.293l2.146-2.147Z",
		"clip-rule": "evenodd"
	}, null, -1)])], 10, s);
}
var l = /* @__PURE__ */ t(o, [["render", c]]);
//#endregion
export { l as default };

//# sourceMappingURL=line-chart.js.map